export default __webpack_public_path__ + "1.17.19/static/media/close.2fccb63b.svg";